import gql from "graphql-tag";

export default gql`
  mutation sendMail($to: String!, $subject: String, $text: String) {
  	sendMail(to: $to, subject: $subject, text: $text)
  }
`;
